import(/* webpackMode: "eager" */ "/home/braid/braided-hedgedoc/frontend/src/app/(editor)/login/page.tsx");
